import React from "react";
import "./Products.css";

// ✅ Import images from src/images
import shalimar1 from "../assets/products/simage1.png";
import shalimar2 from "../assets/products/simage2.png";
import shalimar3 from "../assets/products/simage3.png";
import shalimar4 from "../assets/products/simage4.png";
import jenson1 from "../assets/products/jimage1.png";
import jenson3 from "../assets/products/jimage3.png";
import jenson4 from "../assets/products/jimage4.png";
import jenson5 from "../assets/products/jimage5.png";
import indigo1 from "../assets/products/iimage1.png";
import indigo2 from "../assets/products/iimage2.png";
import indigo3 from "../assets/products/iimage3.png";
import indigo4 from "../assets/products/iimage4.png";
import dulux1 from "../assets/products/dimage1.png";
import dulux3 from "../assets/products/dimage3.png";
import dulux4 from "../assets/products/dimage4.png";
import dulux5 from "../assets/products/dimage5.png";
import duluxLogo from "../assets/logo/dulux-logo1.png";
import indigoLogo from "../assets/logo/indigo-logo1.png";
import jensonLogo from "../assets/logo/jenson-logo.jpg";
import shalimarLogo from "../assets/logo/shalimar-logo-1.png";

const Products = () => {
  const productData = [
    { name: "Super Shaktiman Exterior Emulsion", img: shalimar1 },
    { name: "Water Thinnable Cement primer", img: shalimar2 },
    { name: "Hero Insignia", img: shalimar3 },
    { name: "Silk Eco Interior Emulsion", img: shalimar4 },
    { name: "PU Super Gloss Enamel", img: indigo1 },
    { name: "Leakproof Emulsion", img: indigo2 },
    { name: "D & W Exterior Laminate", img: indigo3 },
    { name: "Luxury Interior Emulsion", img: indigo4 },
    { name: "Velvet Touch Pearl Glo", img: dulux1 },
    { name: "Dulux SuperClean", img: dulux3 },
    { name: "Dulux Weathershield Powerflexx", img: dulux4 },
    { name: "Dulux Promise Interior Primer", img: dulux5 },
    { name: "Universal Cement Primer", img: jenson1 },
    { name: "Wall and Home Painting", img: jenson3 },
    { name: "Decor Exterior Plastic Emulsion", img: jenson4 },
    { name: "Robbialac Super Acrylic Plastic Emulsion", img: jenson5 },
  ];

  return (
    <section className="products" id="paints">
      <h2 className="section-title">Explore Our Products</h2>

      <div className="brand-logos">
        <img src={duluxLogo} alt="dulux Paints" />
        <img src={shalimarLogo} alt="shalimar Paints" />
        <img src={indigoLogo} alt="indigo Paints" />
        <img src={jensonLogo} alt="jenson Paints" />
      </div>

      <h2 className="category-title">Paints</h2>

      <div className="product-grid">
        {productData.map((product, index) => (
          <div key={index} className="product-card">
            <img src={product.img} alt={product.name} />
            <h4>{product.name}</h4>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Products;
